enum NotificationStatuses {
  Default = 'default',
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
}

export default NotificationStatuses;
